// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".justify-end[data-v-451cf6da]{display:flex;justify-content:end}.validation[data-v-451cf6da]{display:flex;flex-direction:row;justify-content:space-around}.loading-creation[data-v-451cf6da]{color:blue}.success-creation[data-v-451cf6da]{color:green}.error-creation[data-v-451cf6da]{color:red}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
